<template>
    <div :class="['screen', { 'onboarding-screen': this.$route.path.includes('onboarding') }]">
        <HeaderView />
        <div v-if="(this.notifications.length > 0)" class="container">
            <RowDiv v-for="(notification, index) in this.notifications" :key="index">
                <div class="col">
                    <HeaderAlert :callback="notification.callback" :extraClass="notification.class"
                        @close="handleCloseAlert(index)" :message="notification.message" />
                </div>
            </RowDiv>
        </div>
        <router-view>
        </router-view>
        <div class="container" v-if="isLoggedIn && !isFramed">
            <RowDiv>
                <div class="col is-center">
                    <SelectableButton class="light small borderless" @click="goToFeedback">
                        <div class="bu1 semi">Tell us what you think!</div>
                    </SelectableButton>
                </div>
            </RowDiv>
        </div>
        <CopyrightFooter />
        <NewVersionToast />
        <InstallApp />
        <GenericToast />
        <div class="modal-overlay" v-if="fromOnboarding">
            <PopUpModal @close="closeWelcome" class="splash">
                <CardDiv>
                    <div class="b1 reg">
                        <p>
                            <b>Welcome to Zilch. Here's what you need to know to get behind the wheel of one of our
                                cars:</b>
                        </p>
                        <ul>
                            <li>
                                <p>Make sure you have a <b>valid driving licence</b>; you will need this before your
                                    first bookings starts</p>
                            </li>
                            <li>
                                <p>If you want to access the fleet for private use, you will need to have a <b>credit
                                        card</b> loaded to your account. If your business is paying, then you are good
                                    to go.</p>
                            </li>
                            <li>
                                <p> Fifteen minutes before the start of your booking, you will get a <b>text message
                                        link to manage your booking</b></p>
                            </li>
                            <li>
                                <p>You need an <b>access card</b> to access our vehicles, if you don't have one, <a
                                        href="mailto:support@zilch.nz">let our
                                        support team know</a>, or call them on 0800 2 ZILCH</p>
                            </li>
                            <li>
                                <p> If you want a car longer term, check out <b>subscriptions</b> available on our
                                    <a target="_blank" href="https://www.zilch.nz/24-7-subscriptions/">website</a>, or
                                    get in touch <a href="mailto:support@zilch.nz">here</a>
                                </p>
                            </li>
                        </ul>
                    </div>
                </CardDiv>
            </PopUpModal>
        </div>
        <div class="modal-overlay" v-show="genericAlert">
            <GenericAlert :data="genericAlert" @close="clearAlert" />
        </div>
    </div>
</template>
<script>
import GenericAlert from './components/common/GenericAlert.vue';
import CopyrightFooter from '@/components/common/CopyrightFooter.vue';
import GenericToast from '@/components/common/GenericToast.vue';
import HeaderView from '@/components/common/HeaderView.vue';
import HeaderAlert from '@/components/common/HeaderAlert.vue';
import InstallApp from '@/components/common/InstallApp.vue';
import NewVersionToast from '@/components/common/NewVersionToast.vue';
import PopUpModal from './components/common/PopUpModal.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
    data() {
        return {
            showAlert: false,
            currentMessage: null,
            messages: [],
        }
    },
    components: {
        CopyrightFooter,
        GenericAlert,
        GenericToast,
        HeaderAlert,
        HeaderView,
        InstallApp,
        NewVersionToast,
        PopUpModal
    },
    computed: {
        shouldShowNotification() {
            return this.profile && this.profile?.show_notification !== 'false';
        },
        ...mapState(['genericAlert', 'notifications', 'isLoggedIn', 'isFramed', 'isAdmin', 'profile', 'paymentMethods', 'costCentres', 'expenseCodes', 'fromOnboarding']),
    },
    beforeMount() {
        if (this.fromOnboarding) {
            this.loadProfile({ router: this.$router, bus: this.$bus }).catch(() => {
                console.error('Could not load the profile');
                this.$router.push({ name: 'Home' });
            });
        }
    },
    methods: {
        clearAlert() {
            this.clearGenericAlert();
        },
        handleCloseAlert(index) {
            this.removeNotification(index);
        },
        goToFeedback() {
            sessionStorage.setItem('feedback', 'feedback');
            this.$router.push({ name: 'Profile' });
            this.$bus.emit('switchToFeedback');
        },
        closeWelcome() {
            this.setFromOnboarding(false);
        },
        ...mapMutations(['clearGenericAlert', 'removeNotification', 'setFromOnboarding']),
        ...mapActions(['loadProfile']),
    },
};
</script>
<style scoped>
.modal-overlay .splash ul li {
    padding-bottom: 2.5rem;
}
</style>